<!--
 * @Author: Src
 * @Date: 2024-07-16 14:09:28
 * @LastEditTime: 2025-07-16 18:51:23
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/shop/ShopReport.vue
 * @Description: 头部注释配置模板
-->
<template>
  <div class="wrap"></div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import StorageService from '@/services/storage.service';
import { Toast, Indicator } from 'mint-ui';
import { $delay } from '@/common/utils';
import BIService from '@/services/bi.service';

@Component({})
export default class ShopReport extends Vue {
  @lazyInject(StorageService)
  protected storage!: StorageService;

  @lazyInject(BIService)
  protected biService!: BIService;

  public shopId!: string;

  public reportUrl?: string;

  public async getBIToken() {
    Indicator.open({
      text: '加载中',
      spinnerType: 'fading-circle',
    });
     const data = {
      worksId: 'cd1e2e78-c83b-4104-9d33-c4aeeff79481',
    };
    try {
      const token = await this.biService.BIToken(data);

      if (!token) {
        return;
      }

      this.reportUrl = `https://bi.aliyuncs.com/dashboard/view/pc.htm?pageId=cd1e2e78-c83b-4104-9d33-c4aeeff79481&param=%5B%7B"paramKey"%3A"shop_id"%2C"conditionList"%3A%5B%7B"operate"%3A"%3D"%2C"value"%3A"${this.shopId}"%7D%5D%2C"joinType"%3A"and"%7D%5D&qbi_version_param=2&accessTicket=${token}`;

      window.location.replace(this.reportUrl);
    } catch (error) {
      Toast({
        message: `${error}`,
        iconClass: 'icon icon-error',
      });
    } finally {
      Indicator.close();
    }
  }

  public async created() {
    const token = this.$route.query.tk;
    const data = {
      token,
    };
    this.storage.set('user',(data));

    const shopId = this.$route.params.id;
    this.shopId = shopId;

    await $delay(500);
    await this.getBIToken();
  }
}
</script>

<style lang="scss" scoped>
.contact-dyh {
  background: #f8f8f8;
  color: #999;
  font-size: 12px;
  text-align: center;
}
</style>
